import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import CheckoutCreditCards from './creditCard/CheckoutCreditCards';
import CheckoutPayPalWrapper from './payPal/CheckoutPayPalWrapper';
import CheckoutWireTransferWrapper from './wireTransfer/CheckoutWireTransferWrapper';
import CheckoutCheckWrapper from './check/CheckoutCheckWrapper';
import CheckoutBankAccounts from './bankAccount/CheckoutBankAccounts';
import CheckoutApplePay from './applePay/CheckoutApplePay';
import { CheckoutKlarnaPayment } from './klarna/CheckoutKlarnaPayment';

import { TABS } from '../constants/checkoutConstants';

const CheckoutPaymentMethodContentComponent = props => {
    const { paymentTab } = props;
    let PaymentComponent;

    switch (paymentTab) {
        case TABS.TAB_CREDIT_CARD:
            PaymentComponent = CheckoutCreditCards;
            break;
        case TABS.TAB_PAYPAL_ACCOUNT:
            PaymentComponent = CheckoutPayPalWrapper;
            break;
        case TABS.TAB_WIRE_TRANSFER:
            PaymentComponent = CheckoutWireTransferWrapper;
            break;
        case TABS.TAB_CHECK:
            PaymentComponent = CheckoutCheckWrapper;
            break;
        case TABS.TAB_BANK_ACCOUNT:
            PaymentComponent = CheckoutBankAccounts;
            break;
        case TABS.TAB_APPLE_PAY:
            PaymentComponent = CheckoutApplePay;
            break;
        case TABS.TAB_KLARNA:
            PaymentComponent = CheckoutKlarnaPayment;
            break;
    }

    if (PaymentComponent) {
        return <PaymentComponent {...props} />;
    }

    return null;
};

CheckoutPaymentMethodContentComponent.propTypes = {
    paymentTab: PropTypes.oneOf(Object.values(TABS)).isRequired,
    viewer: PropTypes.object.isRequired,
};

export const CheckoutPaymentMethodContent = createFragmentContainer(
    CheckoutPaymentMethodContentComponent,
    {
        viewer: graphql`
            fragment CheckoutPaymentMethodContent_viewer on Viewer {
                ...CheckoutCreditCards_viewer
                ...CheckoutPayPalWrapper_viewer
                ...CheckoutWireTransferWrapper_viewer
                ...CheckoutCheckWrapper_viewer
                ...CheckoutBankAccounts_viewer
                ...CheckoutKlarnaPayment_viewer
            }
        `,
        item: graphql`
            fragment CheckoutPaymentMethodContent_item on Item {
                ...CheckoutWireTransferWrapper_item
                ...CheckoutCheckWrapper_item
            }
        `,
        buyer: graphql`
            fragment CheckoutPaymentMethodContent_buyer on User {
                ...CheckoutCreditCards_buyer
                ...CheckoutPayPalWrapper_buyer
                ...CheckoutWireTransferWrapper_buyer
                ...CheckoutCheckWrapper_buyer
                ...CheckoutBankAccounts_buyer
                ...CheckoutKlarnaPayment_buyer
            }
        `,
        transaction: graphql`
            fragment CheckoutPaymentMethodContent_transaction on Transaction {
                ...CheckoutWireTransferWrapper_transaction
                ...CheckoutCheckWrapper_transaction
                ...CheckoutCreditCards_transaction
                ...CheckoutBankAccounts_transaction
                ...CheckoutKlarnaPayment_transaction
            }
        `,
    }
);
